import { FC } from 'react';

import classes from 'classnames';
import { prop } from 'ramda';

import styles from './index.module.css';
import { IBackdropProps } from './types';

const Backdrop: FC<IBackdropProps> = ({ isOpen = false, className, children }) => {
  const rootClasses = classes(styles.root, isOpen && prop('root-active', styles), className);

  return <div className={rootClasses}>{children}</div>;
};

export default Backdrop;
